export default __webpack_public_path__ + "media/4d85d2f73de7cf3d841bccdeedca636704e14513114afc82e2fbe533ba41af78.svg";